import { Store } from '@ngxs/store';
import { FetchTotalWealth } from '../../../actions/total-wealth.action';
import { TemplateHandlebarKeysToCheck } from './action-to-handlebar-key-map';
import { AccountState } from '../../../state/account.state';
import { Injector } from '@angular/core';

/**
 * This map stores the handlebar keys that are associated with widget actions
 * and the corresponding action function to be called when the handlebar key is encountered
 */
export const handlebarToStateActionMap = new Map<TemplateHandlebarKeysToCheck, (injector: Injector) => void>([
  [
    TemplateHandlebarKeysToCheck.FETCH_TOTAL_WEALTH,
    (injector: Injector) => {
      const store = injector.get(Store);
      const activeSelectedCurrency = store.selectSnapshot(AccountState.getCurrentMultiCurrencyCode);
      if (activeSelectedCurrency && activeSelectedCurrency !== 'All') {
        store.dispatch(new FetchTotalWealth(activeSelectedCurrency));
      }
    },
  ],
]);
